import React from "react";
import {BottomNavigation, BottomNavigationAction, Box, Button, Grid, Paper, Stack, styled} from "@mui/material";
import Menu from "./Menu";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
const Dashboard = ()=>{
    return (
        <div>
            <Menu/>
            <div style={{margin:20}}>
                <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    sx={{marginBottom:8}}
                    justifyContent="center"
                    alignItems="center">
                    <Grid justifyContent="center" alignItems="center">
                        <Box sx={{minWidth:"300px",backgroundColor:"#0d47a1",padding:2,margin:2,borderRadius:"7px"}}>
                            <Grid container spacing={2} sx={{marginTop:2,width:"100%"}}>
                                <Grid xs={6}>
                                    <MonetizationOnIcon sx={{ fontSize: 120,color:"#4575bb" }}/>
                                </Grid>
                                <Grid xs={6} sx={{textAlign:"right"}}>
                                    <div>
                                        <p style={{color:"#FFFFFF",fontWeight:"bold",fontSize:"18px"}}>مانده حساب</p>
                                        <span style={{color:"#FFFFFF"}}>20,000,000</span>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid justifyContent="center" alignItems="center">
                        <Box sx={{minWidth:"300px",backgroundColor:"#e53935",padding:2,margin:2,borderRadius:"7px"}}>
                            <Grid container spacing={2} sx={{marginTop:2,width:"100%"}}>
                                <Grid xs={6}>
                                    <ListAltIcon sx={{ fontSize: 120,color:"#e06d6b" }}/>
                                </Grid>
                                <Grid xs={6} sx={{textAlign:"right"}}>
                                    <div>
                                        <p style={{color:"#FFFFFF",fontWeight:"bold",fontSize:"18px"}}>فاکتورها</p>
                                        <span style={{color:"#FFFFFF"}}>32</span>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid justifyContent="center" alignItems="center">
                        <Box sx={{minWidth:"300px",backgroundColor:"#f9a825",padding:2,margin:2,borderRadius:"7px"}}>
                            <Grid container spacing={2} sx={{marginTop:2,width:"100%"}}>
                                <Grid xs={6}>
                                    <HourglassEmptyRoundedIcon sx={{ fontSize: 120,color:"#fabc5b" }}/>
                                </Grid>
                                <Grid xs={6} sx={{textAlign:"right"}}>
                                    <div>
                                        <p style={{color:"#FFFFFF",fontWeight:"bold",fontSize:"18px"}}>فاکتور های در انتظار</p>
                                        <span style={{color:"#FFFFFF"}}>0</span>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0,margin:"auto"}} elevation={3}>
                    <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <Button
                            variant="contained"
                            size="large"
                            color="info"
                            sx={{padding:1,marginBottom:1,width:"94%",backgroundColor:"#092350"}}> ثبت سفارش جدید <PostAddRoundedIcon/>
                        </Button>
                    </div>
                </Paper>
            </div>
        </div>

    )
}
export default Dashboard